<template>
  <div>
    <Card>
      <Row>
        <Button type="info"
                @click="add">{{$t('pages_banners_index_178')}}</Button>
      </Row>
      <TablePaginate :columns="columns"
                     :data="desks"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="formType === 'new' ? $t('pages_desk_index_470') : $t('pages_desk_index_471')">
      <Form ref="category"
            :model="desk"
            :label-width="120">
        <Form-item :label="$t('pages_desk_index_472')"
                   prop="name">
          <Input type="text"
                 v-model="desk.name" />
        </Form-item>
        <Form-item :label="$t('pages_desk_index_473')"
                   prop="fresh_desk_partition_id">
          <Select label-in-value
                  v-model="desk.fresh_desk_partition_id">
            <Option v-for="item in desk_partitions"
                    :value="item.id"
                    :key="item.id">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_banners_index_192')"
                   prop="category">
          <Select label-in-value
                  v-model="desk.category">
            <Option v-for="item in deskCategories"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_desk_index_474')"
                   prop="position">
          <Input type="text"
                 v-model="desk.position" />
        </Form-item>
        <Form-item :label="$t('pages_desk_index_475')"
                   prop="is_show">
          <i-switch size="large" v-model="desk.is_show">
            <span slot="open">{{$t('libs_table_render_50')}}</span>
            <span slot="close">{{$t('directives_index_41')}}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import {
  deleteButtonInTable,
  editorButtonInTable,
  commonButtonInTable,
  tableAvatar2,
  downloadImgInTable, booleanChinese
} from '@/libs/table-render'
import { deskCategories } from '@/libs/value-list.js'
export default {
  components: {
    TablePaginate,
  },
  data () {
    const that = this;
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: 'ID',
          width: 80,
          key: 'id',
          align: 'center'
        },
        {
          title: i18n.t('pages_desk_index_476'),
          key: 'name'
        },
        {
          title: i18n.t('pages_desk_index_477'),
          align: 'center',
          key: 'qr_code_url',
          width: 200,
          render: (h, params) => {
            return params.row.category === 'union' ? tableAvatar2(h, params.row.qr_code_url) : ''
          }
        },
        {
          title: '餐桌码二维码内容',
          align: 'center',
          width: 100,
          key: 'qr_code_content'
        },
        {
          title: i18n.t('pages_desk_index_474'),
          align: 'center',
          width: 100,
          key: 'position'
        },
        {
          title: i18n.t('pages_booking_store_products_index_220'),
          align: 'center',
          width: 100,
          render: (h, params) => {
            return h('div', {}, params.row.category === 'union' ? '整桌' : i18n.t('libs_value_list_107'))
          }
        },
        {
          title: i18n.t('pages_desk_index_475'),
          align: 'center',
          width: 130,
          key: 'is_show',
          render: (h, params) => {
            return booleanChinese(h, params.row.is_show)
          }
        },
        {
          title: i18n.t('pages_desk_index_473'),
          key: 'fresh_desk_partition_id',
          width: 200,
          align: 'center',
          render: (h, params) => {
            return h('div', that.getDeskPartitionName(params))
          }
        },
        {
          title: i18n.t('pages_ai_image_163'),
          key: 'action',
          width: 280,
          align: 'center',
          fixed: 'right',
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            if (params.row.category === 'apart') {
              children.push(commonButtonInTable(this,
                h,
                'info',
                i18n.t('pages_desk_index_478'),
                this.routeSeats,
                [params.row]))
            }
            if (params.row.category === 'union' && params.row.qr_code_url) {
              children.push(downloadImgInTable(
                this,
                h,
                {
                  title: i18n.t('pages_desk_index_479'),
                  url: params.row.qr_code_url
                }
              ))
            }
            return h('div', children)
          }
        }
      ],
      deskCategories
    }
  },
  created () {
    this.changeQuery({ page: 1, is_show: 'all' })
    this.index()
    this.desk_partition_index()
    this.display()
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('desk', ['desk', 'desks', 'meta', 'loading']),
    ...mapState('desk_partition', ['desk_partitions'])
  },
  methods: {
    ...mapActions('desk', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapActions('desk_partition', {
      desk_partition_index: 'index'
    }),
    ...mapActions('setting', ['display', 'upgrade']),

    ...mapMutations('desk', ['changeQuery']),
    routeSeats (row) {
      this.$router.push({
        path: '/desks/seats',
        query: {
          fresh_desk_id: row.id,
          desk_name: encodeURIComponent(row.name),
        }
      })
    },
    getDeskPartitionName ({ row }) {
      const result = this.desk_partitions.find(item => item.id === row.fresh_desk_partition_id)
      return result ? result.name : ''
    },
    changePage (page) {
      this.changeQuery({ page: page, is_show: 'all' })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
      this.desk.is_show = true
    },
    uploadedUrl (url) {
      this.desk.image = url
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.desk)
      } else if (this.formType === 'new') {
        await this.create(this.desk)
      }
      this.modalShow = false
    },
    change_desk_auto_upgrade () {
      this.upgrade({ desk_auto_upgrade: this.setting.desk_auto_upgrade })
    },
  }
}
</script>
